import { Form } from 'react-final-form';
import Field from './Field';
import '../../../../styles/scss/app/Form.scss';
import { Button, Tooltip } from '@mui/material';
import DeleteSweepRoundedIcon from '@mui/icons-material/DeleteSweepRounded';

const form = (props) => {
  const {
    onSubmit,
    initialValues,
    formConfig,
    translations,
    className,
    disableAll,
    submitLabel,
    decoratedOnClick,
    showResetButton,
    onReset,
    resetButtonLabel,
    clearFiltersTooltip,
  } = props || {};
  const { fields } = formConfig || {};

  const renderField = (field, index, values) => (
    <Field
      key={`${field?.name}_${index}`}
      field={field}
      values={values}
      translations={translations}
      disable={disableAll}
      size={field.size}
    />
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues || {}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} className={`${className} Form`}>
          <div className="fields">
            {fields &&
              fields.map(
                (field, index) =>
                  !field.notVisible && renderField(field, index, values)
              )}
          </div>
          <div className="mt-2 d-flex justify-content-end gap-3">
            <Button
              className={`px-2 default-btn-info align-items-center`}
              disabled={submitting || pristine}
              type="submit"
              onClick={decoratedOnClick}
              size="small"
              startIcon={<i className="fa-solid fa-magnifying-glass" />}
            >
              {submitLabel}
            </Button>
            {showResetButton && (
              <Tooltip
                title={clearFiltersTooltip}
                arrow={true}
                placement={'top'}
              >
                <Button
                  className={'px-2 default-btn-danger align-items-center'}
                  onClick={onReset}
                  size="small"
                  startIcon={
                    <DeleteSweepRoundedIcon fontSize="large" role="button" />
                  }
                >
                  {resetButtonLabel}
                </Button>
              </Tooltip>
            )}
          </div>
        </form>
      )}
    />
  );
};

export default form;
